import {
  ICompanyJobLevelPure,
  ICompanyJobPure,
  ICompanyMemberPure,
  ICompanyPure,
  ICompanySkillPure,
} from '../models/Company'
import { getLevelSkills } from './company.helper'

const getJobOfMember = (
  member: ICompanyMemberPure,
  company: ICompanyPure
): ICompanyJobPure | undefined => {
  if (!member.job) {
    return undefined
  }
  const memberJob = company.jobs?.find(
    (j) => j._id + '' === member.job?.jobId + ''
  )
  return memberJob
}

const getJobLevelOfMember = (
  member: ICompanyMemberPure,
  company: ICompanyPure
): ICompanyJobLevelPure | undefined => {
  const memberJob = getJobOfMember(member, company)
  if (!memberJob) {
    return undefined
  }
  const memberJobLevel = memberJob?.levels.find(
    (jl) => jl._id + '' === member.job?.jobLevelId + ''
  )
  return memberJobLevel
}

export const getJobProfileOfMember = (
  member: ICompanyMemberPure,
  company: ICompanyPure
): {
  job: ICompanyJobPure | undefined
  jobLevel: ICompanyJobLevelPure | undefined
} => {
  const job = getJobOfMember(member, company)
  const jobLevel = job?.levels.find(
    (jl) => jl._id + '' === member.job?.jobLevelId + ''
  )
  return { job, jobLevel }
}

// In the level's own order. This used to filter the library, which put the
// evaluation form and the feedback competencies in record-creation order while
// the job profile, the export and the public page all followed `skillsIds` —
// and a feedback request froze that disagreeing order into the document.
// Inactive records come along: callers that show them filter `inactive`
// themselves, and historical data still has to resolve.
export const getSkillsForMember = (
  member: ICompanyMemberPure,
  company: ICompanyPure
): ICompanySkillPure[] =>
  getLevelSkills(getJobLevelOfMember(member, company), company, {
    includeInactive: true,
  })

export const memberHasNoSkills = (
  member: ICompanyMemberPure,
  company: ICompanyPure
) => {
  const memberLevelSkills = getSkillsForMember(member, company)

  return !!(!memberLevelSkills || memberLevelSkills.length === 0)
}

export const getTeamMembersOfMember = (
  member: ICompanyMemberPure,
  company: ICompanyPure
) => {
  return company.members.filter(
    (companyMember) =>
      companyMember.teams[0]?.teamId + '' === member.teams[0]?.teamId + '' &&
      companyMember._id + '' !== member._id + ''
  )
}
